<template>
    <div class="dashlet">
      <div class="mb-1 pr-0 pl-1 dashlet">
        <div class="ibox-body dashlet">
					<div class="ibox-title style_2 d-flex justify-content-between">
						<div class="ibox-tools">
							<img src="../../assets/img/open_query.png" alt="Open Query Widget">
						</div>
						<h5>{{$t('navigations.open query')}}</h5>
					</div>
					<div class="ibox-content contentheight">
						<h1 class="no-margins">{{ querycountstd }}</h1>
						<small>{{$t('navigations.open query')}}</small>
					</div>
				</div>
      </div>
    </div>
  </template>
  
  <script>
  /* eslint-disable */
  import axios from "axios";
  import store from "@/store";
  export default {
    name: 'openquery',
    data() {
    return {
      baseapi: process.env.VUE_APP_Service_URL,
      querycountstd:"",
    }
  },
  async mounted() {
    window.addEventListener("studyIdChanged", async (event) => {
      await this.getquerycount();
		});
    await this.getquerycount();
  },
    methods:{

    async getquerycount() {
            const idtoken = store.getters.getIdToken;
            const currentstudyid = await store.getters.getStudyIs;
			await axios
				.get(
					`${this.baseapi}/forms/query/getcounts?studyId=${currentstudyid}`,
					{
						headers: {
							"Access-Control-Allow-Origin": "localhost:8080",
							Authorization: "Bearer " + idtoken,
							"Content-Type": "application/json",
						},
					}
				)
				.then((res) => {
					this.querycountstd = res.data;
				})
				.catch((err) => {
					console.log(err);
				});
		},
    }
  };
  </script>
  
  <style>
  .dashlet{
    width:100%;
    height:100%;
  }
  .contentheight{
    height: calc(100% - 48px);
  }
</style>